import React, { Component } from "react";
import { Button, Spinner } from "react-bootstrap";
import ResearchPage from "../Images/research.jpg";

class Research extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <img className="img-fluid" src={ResearchPage} alt="Founders" />
        <h1 className="page-header text-center head">Educational Research</h1>
        <h3>Purpose</h3>
        <p>
          The purpose of the programme is to “guide” students to write theses,
          dissertations, long essays and seminars with less difficulty and to
          present them skillfully. Identify, assess, train and support.
        </p>
        <h3>Objectives</h3>
        <p>Objectives of the programme are to:</p>
        <ol>
          <li>
            Enable research students select Topics and conduct research with
            ease as they master the skills involved in writing research
            proposals.
          </li>
          <li>
            Guide the young researchers to identify and solve problems in the
            community through research.
          </li>
          <li>Write “winning” proposals.</li>
          <li>Write Research Papers.</li>
          <li>Review papers, critique and summarize.</li>
          <li>Learn the tips of Viva-Voce.</li>
          <li>
            Disseminate research report through publications, seminars, radio
            presentations etc.
          </li>
        </ol>
        <h3>Guided Writing</h3>
        <p>
          Students will be ‘Guided’ technically to write theses, dissertations,
          projects, long essays and seminar papers.
        </p>
        <ul>
          <li>General introduction to research.</li>
          <li>Choice of topic of study.</li>
          <li>Writing research proposals - giving technical guidance.</li>
          <li>Approaches: qualitative and quantitative/ mixed method.</li>
          <li>Treating specific research chapters as the following:</li>
        </ul>
        <h6>Chapter One</h6>
        <p>Introduction</p>
        <ul>
          <li>Background to the study.</li>
          <li>Statement of problem.</li>
          <li>Purpose of study.</li>
          <li>Objectives.</li>
          <li>Research questions.</li>
          <li>Hypothesis.</li>
          <li>Delimitation.</li>
          <li>Significance of study.</li>
          <li>Definition of terms.</li>
          <li>Organization of study.</li>
        </ul>
        <h6>Chapter Two</h6>
        <p>Literature Review</p>
        <ul>
          <li>Introduction of the content of the chapter.</li>
          <li>Related strands/ related topics.</li>
          <li>Theoretical framework.</li>
          <li>Empirical framework- (to be subsumed under a related strand).</li>
          <li>
            Positioning- (Your own position or stand of the Literature Review).
          </li>
          <li>Conceptual framework</li>
          <li>Summary of the literature- (to include Gaps identified)</li>
        </ul>
        <h6>Chapter Three</h6>
        <p>Research Methodology- various steps will be developed</p>
        <h6>Chapter Four</h6>
        <p>Result/Findings.</p>
        <h6>Chapter Fiive</h6>
        <p>Discussions of Findings (of the research)</p>
        <h6>Chapter Six</h6>
        <p>Summary of Finding, Conclusions and Recommendations.</p>
        <h6>Reference</h6>
        <p>
          In-text and out-of-text referencing must be according to current APA
          or the style of the institutions.
        </p>
        <h6>Appendices</h6>
        <p>.................</p>
        <h3>VIVAVOCE</h3>
        <p>
          Stand and deliver: Learn the act and the art of presenting a Viva Voce
          for SUCCESS!
        </p>
        <h3>Dissemination</h3>
        <p> Publication of Articles from Research Papers.</p>
        <h3>Other Areas</h3>
        <ol>
          <li>
            Grants proposal writing-“winning proposals” (visiting lecturer(s) in
            charge) for Faculty and Ph.D graduate students and lecturers
            (learners will be guided to write).
          </li>
          <li>
            Writing scientific paper. How to write scientific papers for
            publications in peer reviewed journals. (Visiting Lecturer(s)).
          </li>
          <li>Paper Review.</li>
          <li>Journal article Critiquing.</li>
        </ol>
        <p>
          <u>Note:</u> Visiting Lecturers from some selected Universities in
          Ghana will be in charge of some selected topics in research, projects
          / M.Ed, M.Sc., M.A, M.Phil, Ph.D.
        </p>
        <a href="https://forms.gle/3dxfDmfNPvopaR9t7" target="blank">
          <div className="text-center ">
            <Button variant="success" className="sign-up">
              <Spinner
                as="span"
                animation="grow"
                size="md"
                role="status"
                aria-hidden="true"
              />
              Sign up here...
            </Button>
          </div>
        </a>
      </div>
    );
  }
}

export default Research;
